module.exports = __webpack_public_path__ + "img/you-get-image.ffd4359b.jpg";